export default "__VITE_ASSET__B9HXAUU7__"